import { render } from "./ManageServiceSlots.vue?vue&type=template&id=1a99656a&scoped=true"
import script from "./ManageServiceSlots.vue?vue&type=script&lang=js"
export * from "./ManageServiceSlots.vue?vue&type=script&lang=js"

import "./ManageServiceSlots.vue?vue&type=style&index=0&id=1a99656a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a99656a"]])

export default __exports__